import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import classNames from 'classnames'
import { useGetMobileBanner, WebBannerDataV1Action } from '@/api/kubik/infoportal'
import { Image, Skeleton } from '@/components/ui'
import { useAuthenticateUser } from '@/components/ui/AuthButton/hooks'
import { MATCH_MEDIA_QUERIES } from '@/constants/common'
import { JOURNAL_TAG_ATTRIBUTES } from '@/constants/journal'
import { getMinioImagePath } from '@/utils/images'
import type { IPublicationComponentProps } from '../types'
import { skeletons } from './constants'

const { articleBanner } = JOURNAL_TAG_ATTRIBUTES

export const PublicationBanner = (props: IPublicationComponentProps) => {
  const { attribs } = props
  const { openAuthModal, isAuthenticated } = useAuthenticateUser()

  const parsedBannerName = attribs[articleBanner.bannerId]

  const { data, isLoading, isSuccess, isError } = useGetMobileBanner(parsedBannerName || '', {
    query: { staleTime: Infinity, enabled: !!parsedBannerName },
  })
  const isBannerInteractable = data?.data?.action === WebBannerDataV1Action.REGISTRATION_FORM && !isAuthenticated

  const onBannerClick = () => {
    if (!data?.data) return
    if (isBannerInteractable) openAuthModal()
  }

  if ((!data?.data?.id && isSuccess) || isError) return null

  return (
    <div className={classNames('publicationText__articleBanner', { 'publicationText__articleBanner--interactable': isBannerInteractable })}>
      <Skeleton isLoading={isLoading} skeletons={skeletons}>
        <CommonLink
          spanIfEmpty
          url={data?.data?.action === WebBannerDataV1Action.URL ? data?.data?.url : undefined}
          onClick={onBannerClick}
        >
          <picture>
            <source srcSet={getMinioImagePath({ src: data?.data?.mobileImgUrl })} media={MATCH_MEDIA_QUERIES.mobile} />
            <Image src={data?.data?.desktopImgUrl} />
          </picture>
        </CommonLink>
      </Skeleton>
    </div>
  )
}
